import { tryGetHostApi } from "../app/externalApi/externalApi";
import { addPartCData } from "./TraceLogging";
// Wrapper class for logging Telemetry events
// Telemetry events are sampled at 0% on external devices, but can be upsampled via override.
// This is commonly used to evaluate the effect of a newly released feature on release or update, which can then be turned off when enough data has been gathered.
// Telemetry is also useful for collecting self-host and WIP data that may only be useful during development
// See https://www.osgwiki.com/wiki/Telemetry_categories for extra information
export default class Telemetry {
    static async logEvent(provider, eventName, privacyTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 35184372088832 /* telemetry */, 0 /* none */, 0 /* verbose */, await addPartCData(partC));
        }
    }
    static async logEventWithTag(provider, eventName, privacyTag, eventTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 35184372088832 /* telemetry */, eventTag, 0 /* verbose */, await addPartCData(partC));
        }
    }
    static async logEventWithLevel(provider, eventName, privacyTag, loggingLevel, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 35184372088832 /* telemetry */, 0 /* none */, loggingLevel, await addPartCData(partC));
        }
    }
    static async logEventWithLevelAndTag(provider, eventName, privacyTag, loggingLevel, eventTag, partC) {
        const telemetryApi = await tryGetHostApi("Telemetry", 1, 1);
        if (telemetryApi) {
            telemetryApi.logEvent(eventName, provider, privacyTag, 35184372088832 /* telemetry */, eventTag, loggingLevel, await addPartCData(partC));
        }
    }
}
